import { times, sample } from 'lodash';

export { isEnvMobile, isIos, getParamFromUrlHashByKey, setCookie, getCookie } from './browser'

export { MonitorKeyboard } from './monitorKeyboard'

export { aesEncrypt, aesDecrypt } from './encrypt.js'


// 指定长度和基数
export function generateUUID(len = 16, radix = 16) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}

export const disabledScrollUtil = {
  isDisabled: false, // 是否已禁止
  scrollTop: 0, // 滚动距离
  disableScroll() {
    // 防止背景滚动
    this.scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0; // 保存当前滚动条位置
    document.body.style.top = `-${this.scrollTop}px`;
    this.isDisabled = true;
    document
      .getElementsByTagName('body')[0]
      .classList.add('kos-overflow-hidden');
  },
  scroll() {
    // 解除背景滚动，并滚动到原来的位置
    document
      .getElementsByTagName('body')[0]
      .classList.remove('kos-overflow-hidden');
    window.scrollTo(0, this.scrollTop); // 去掉fixed后，滚动到原来的位置
    document.body.style.top = '';
    this.isDisabled = false;
  }
}

/**
 * 随机生成字符串
 * @param {Number} length 字符串长度
 * @returns 字符串
 */
export function generateRandomString(length) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return times(length, () => sample(chars)).join('');
}
